const DEFAULT_TIER_COLOR = "#3699FF";

export function nextTierMinPoint(tiers) {
  const items = Array.isArray(tiers) ? tiers : [];
  const previousTier = items.length ? items[items.length - 1] : null;

  return {
    previousTier,
    minPointFloor: previousTier ? (Number(previousTier.min_point) || 0) + 1 : 0
  };
}

export function isTopTier(tiers, tierId) {
  const items = Array.isArray(tiers) ? tiers : [];
  const top = items.reduce(
    (highest, tier) =>
      !highest || Number(tier.tier_order) > Number(highest.tier_order) ? tier : highest,
    null
  );
  return !!top && Number(top.id) === Number(tierId);
}

export function rewardTierBadges(tierIds, memberTiers) {
  const ids = Array.isArray(tierIds) ? tierIds : [];
  const tiers = Array.isArray(memberTiers) ? memberTiers : [];

  return ids
    .map((id) => {
      const tier = tiers.find((t) => Number(t.id) === Number(id));
      return {
        name: tier ? tier.name : `Tier ${id}`,
        color: (tier && tier.color) || DEFAULT_TIER_COLOR,
        tier_order: tier ? Number(tier.tier_order) : Number.MAX_SAFE_INTEGER
      };
    })
    .sort((a, b) => a.tier_order - b.tier_order);
}

export function allowedMultipliers(multipliers, tiers, currentTierId = null) {
  const items = Array.isArray(tiers) ? tiers : [];
  const current = items.find((t) => Number(t.id) === Number(currentTierId));
  const siblings = items.filter((t) => t !== current);
  const multiplierOf = (tier) => Number(tier.point_multiplier) || 1;
  const isLower = (tier) =>
    !current || Number(tier.tier_order) < Number(current.tier_order);

  const floor = Math.max(
    -Infinity,
    ...siblings.filter(isLower).map(multiplierOf)
  );
  const ceiling = Math.min(
    Infinity,
    ...siblings.filter((tier) => !isLower(tier)).map(multiplierOf)
  );

  return multipliers.filter((value) => value > floor && value < ceiling);
}

export function previewNeighborRangeChanges(tiers, tierId, minPoint, maxPoint) {
  const items = (Array.isArray(tiers) ? tiers : [])
    .slice()
    .sort((a, b) => Number(a.tier_order) - Number(b.tier_order));
  const isNewTier = tierId === null || tierId === undefined;
  const index = isNewTier
    ? items.length
    : items.findIndex((tier) => Number(tier.id) === Number(tierId));
  if (index < 0) {
    return [];
  }

  const isProvided = (value) => value !== null && value !== undefined && value !== "";
  const toPoint = (value) => (isProvided(value) ? Number(value) : null);
  const rangeOf = (tier) => ({ min: toPoint(tier.min_point) || 0, max: toPoint(tier.max_point) });
  const lowerTier = index > 0 ? items[index - 1] : null;
  const upperTier = isNewTier ? null : items[index + 1] || null;
  const changes = [];

  if (lowerTier && isProvided(minPoint)) {
    const before = rangeOf(lowerTier);
    const after = { min: before.min, max: Number(minPoint) - 1 };
    if (before.max !== after.max) {
      changes.push({ tier: lowerTier, before, after });
    }
  }

  if (upperTier && isProvided(maxPoint)) {
    const before = rangeOf(upperTier);
    const after = { min: Number(maxPoint) + 1, max: before.max };
    if (before.min !== after.min) {
      changes.push({ tier: upperTier, before, after });
    }
  }

  return changes;
}
